<template>
  <v-card data-component-id="MassRejectApplications">
    <v-card-title>
      <p class="col-12 text-center pa-0 mb-0">
        ⚠️ Confirmer la clôture du recrutement !
      </p>
    </v-card-title>
    <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="primary"
    />
    <v-card-text>
      <p class="text-center">
        <strong>Attention</strong> : Tous les candidats n'ayant pas un statut finalisé
        (Embauché, etc.) seront automatiquement refusés.
      </p>
      <p class="text-center">
        Assurez-vous d'avoir bien mis à jour le statut de votre candidat
        retenu avant de confirmer.
      </p>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        text
        @click="handleDisagree"
      >
        Annuler
      </v-btn>
      <v-btn
        :disabled="isLoading"
        color="primary"
        text
        @click="handleAccept"
      >
        Confirmer la clôture
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import store from '@/store';
import { requests } from '@/mixins/requests';

const emit = defineEmits(['close-dialog', 'handle-loading']);

const props = defineProps({
  item: {
    type: Object,
    default: () => ({})
  },
  offerUuid: {
    type: String,
    default: null
  }
});

const isLoading = ref(false);

const handleLoading = value => {
  emit('handle-loading', value);
  isLoading.value = value;
};

const handleDisagree = () => {
  emit('close-dialog');
};

const handleAccept = async () => {
  handleLoading(true);

  try {
    const response = await requests.closeApplications(props.offerUuid);

    if (!response.success) {
      store.commit('setSnackbar', {
        text: "Erreur lors de la dépublication de l'offre.",
        color: 'error'
      });
      return;
    }

    const { successful, skippedHired } = response.data;

    if (successful > 0) {
      store.commit('setSnackbar', {
        text: `Refus en masse terminé : ${successful} candidature(s) refusée(s), ${skippedHired} ignorée(s).`,
        color: 'success'
      });
    } else {
      store.commit('setSnackbar', {
        text: `Aucune candidature n'a été refusée. ${skippedHired} candidatures ont été ignorées car leur statut est avancé.`,
        color: 'info'
      });
    }

    store.commit('setOffer', { ...props.item, status: 'draft' });
  } finally {
    emit('close-dialog');
    handleLoading(false);
  }
};
</script>
